import utils from '@/utils/common';
export function isWeChatApplet() {
  const userAgent = window.navigator.userAgent.toLowerCase()
  return new Promise(resolve => {
      if(userAgent.indexOf('micromessenger') == -1) { //不在微信或小程序
          resolve(true)
      } else {
        try {
            wx.miniProgram && wx.miniProgram.getEnv(res => {
                if(res.miniprogram) {
                    resolve(false)  // 小程序
                } else {
                    resolve(true)
                }
            }) 
        } catch (error) {
            resolve(true)
        }
      }
  })
}

export function jumpToActPreview(item) {
    let params = {}
    item.linkValue.split('?')[1] && item.linkValue.split('?')[1].split('&').forEach(item => {
        let strArr = item.split('=');
        params[strArr[0]] = strArr[1];
    });
    utils.jumpToNewPage({
        url: item.linkValue,
        barColor: params.naviBarColor && '#' + params.naviBarColor
    });
}

export const getBeeOrigin = () => {
    let origin = '';
    switch(process.env.VUE_APP_CURRENTMODE) {
        case 'testc':
            origin = 'https://k100-testc.chinabeego.com/h5user'
            break;
        case 'pre':
            origin = 'https://k100-pre.chinabeego.com/h5user'
            break;
        case 'prod':
            origin = 'https://k100.chinabeego.com/h5user'
            break;
        default:
            origin = 'https://k100-test.chinabeego.com/h5user'
            break;
    }
    return origin
}

export function navigateToLoginPage() {
  switch(window.isApp) {
    case 'Android':
    case 'IOS':
      if(process.env.NODE_ENV !== 'production') {
        console.log('当前环境不支持登录')
        return
      }
      utils.needUserLogin();
      break;
    case 'miniApp':
      wx.miniProgram.navigateTo({url:"/others/pages/author-login/index?fromurl=WEBVIEW"})
      break;
    case 'wxwork':
      wx.miniProgram.navigateTo({url:"/packages/main/pages/login/index"}) 
      break;      
  }
}

export function getUtmInfo(utm_click_source_type_evar,utm_click_source_content_evar,utm_click_source_keyword_evar){
    var utmInfo =  JSON.parse(sessionStorage.getItem('utmInfo')) || null;
    utmInfo.utm_click_source_type_evar = utm_click_source_type_evar || "";    //店铺、商品、活动
    utmInfo.utm_click_source_content_evar = utm_click_source_content_evar || "";    //  搜索、首页商品推荐等等
    utmInfo.utm_click_source_keyword_evar = utm_click_source_keyword_evar || "";    // 搜索关键字
    sessionStorage.setItem('utmInfo',JSON.stringify(utmInfo))
}

export function deepClone(val, defaultVal) {
  try {
    val = JSON.parse(JSON.stringify(val))
  } catch (error) {
    val = defaultVal
  }
  return val
}